import { Injectable } from '@angular/core';
import { IsThreeJsType } from '@3d-scene/common/util/is-threejs-type';
import { Object3DUtils } from '@3d-scene/common/util/object-3d-utils';
import { SceneManager } from '@3d-scene/manager/scene.manager';
import { ContainerService } from '@3d-scene/model3d/container.service';
import { Log } from '@shared/debug/log';
import { Color, Material } from 'three';

export type EditMaterialsInfo = { colorToUse: string; opacityToUse: number; materials: Material[] };

@Injectable({
  providedIn: 'root'
})
export class AdmintoolMaterialsService {

  constructor(
    private containerService: ContainerService,
    private sceneManager: SceneManager,
  ) {
  }


  /** @returns the materials in the scene as Map<string, Material[]>.
   * The key is in the format of {hexcode}-{opacity}. For example 'ff00ff-0.5' for half transparent magenta */
  public getSceneMaterialsByHexCodeAndOpacity(): Map<string, Material[]> {
    const materialsWithColor = this.containerService.enumerateArticleContainersInGlobal()
      .flatMap(Object3DUtils.getObjectsMaterials)
      .filter((material) => material.hasOwnProperty('color'));

    const materialsByHexCodeAndOpacity = new Map<string, Material[]>();
    for (const mat of materialsWithColor) {
      const hexString = ((mat as any)['color'] as Color).getHexString();
      const opacity = mat.opacity;

      const colorKey = `${hexString}-${opacity}`;

      if (!materialsByHexCodeAndOpacity.has(colorKey)) {
        materialsByHexCodeAndOpacity.set(colorKey, []);
      }
      materialsByHexCodeAndOpacity.get(colorKey)!.push(mat);
    }

    return materialsByHexCodeAndOpacity;
  }

  public applyMaterialChanges(materialsInfos: EditMaterialsInfo[]): void {
    for (const materialsInfo of materialsInfos) {
      for (const material of materialsInfo.materials) {
        material.transparent = materialsInfo.opacityToUse < 1.0;
        material.opacity = materialsInfo.opacityToUse;

        const color = (material as any)['color'] as Color;
        if (Log.assert(IsThreeJsType.color(color))) {
          color.set(materialsInfo.colorToUse);
        }
        material.needsUpdate = true;
      }
    }
    this.sceneManager.renderScene();
  }
}
